import { guides } from './guides';
import { useCases } from './use-cases';
import { alternatives } from './alternatives';
import type { Article, ContentCollection } from './types';

export * from './types';

/** Every content article across all collections. */
export const allArticles: Article[] = [...guides, ...useCases, ...alternatives];

export { guides, useCases, alternatives };

export function articlesInCollection(collection: ContentCollection): Article[] {
  return allArticles.filter((a) => a.collection === collection);
}

export function getArticle(collection: ContentCollection, slug: string): Article | undefined {
  return allArticles.find((a) => a.collection === collection && a.slug === slug);
}
